export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  quality: string;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  genre: string[];
  region: string;
  duration: string;
  releaseDate: string;
  poster: string;
  banner: string;
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: 'movie',
    year: 2026,
    rating: 9.2,
    quality: '4K',
    description: '太阳急速老化，地球再次面临存亡危机。人类团结一致，启动前所未有的星际远航计划，在广袤宇宙中寻找新的家园。',
    longDescription: '在《流浪地球3》中，地球发动机全面启动，人类文明进入了最关键的转折点。面对未知的星际空间和神秘的外星信号，联合政府做出了一个改变人类命运的决定。影片以前所未有的视觉奇观呈现了人类在宇宙尺度上的壮丽迁徙，同时也深入探讨了文明存续、人性光辉与牺牲精神的宏大主题。全片采用IMAX摄影机拍摄，特效镜头超过3000个，是华语科幻电影的里程碑之作。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    genre: ['科幻', '冒险', '灾难'],
    region: '中国大陆',
    duration: '173分钟',
    releaseDate: '2026-02-10',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%2C%20planet%20Earth%20with%20glowing%20engines%20in%20deep%20space%2C%20dramatic%20cinematic%20lighting%20with%20orange%20and%20blue%20contrast%2C%20clean%20dark%20background%2C%20movie%20poster%20style%20with%20bold%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20giant%20planet%20Earth%20with%20massive%20glowing%20engines%20floating%20through%20nebula%2C%20dark%20cosmic%20background%20with%20stars%2C%20dramatic%20orange%20light%2C%20Hollywood%20blockbuster%20cinematic%20style%2C%20high%20contrast%2C%20atmospheric&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    title: '长安三万里2',
    titleEn: "Chang'an 2",
    category: 'anime',
    year: 2026,
    rating: 9.0,
    quality: '4K',
    description: '盛唐风华再现，李白与杜甫的传奇故事继续。诗酒趁年华，万里长安路，一段关于诗与远方的动人叙事。',
    longDescription: '《长安三万里2》延续前作的史诗叙事，以更加宏大的视角展现了盛唐时期的文人风骨与家国情怀。影片聚焦李白流放夜郎后的传奇经历，以及他与杜甫跨越时空的精神对话。通过精美的动画技术，将唐诗的意境与盛唐的繁华完美呈现，每一帧画面都宛如一幅流动的水墨画卷。影片在传承中国传统文化的同时，以现代动画语言讲述了关于梦想、友谊与坚持的动人故事。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    genre: ['动画', '历史', '剧情'],
    region: '中国大陆',
    duration: '168分钟',
    releaseDate: '2026-07-08',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20ancient%20Tang%20Dynasty%20palace%20with%20poet%20figure%20in%20traditional%20robes%2C%20ink%20wash%20painting%20style%20with%20golden%20accents%2C%20elegant%20artistic%20composition%2C%20dark%20background%20with%20warm%20highlights%2C%20no%20text&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%2C%20golden%20palace%20rooftops%20at%20sunset%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20warm%20golden%20light%2C%20artistic%20cinematic%20style%2C%20atmospheric%20mist%2C%20beautiful%20composition&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    featured: true,
    isNew: true,
    isHot: true,
  },
  {
    id: 3,
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    category: 'movie',
    year: 2025,
    rating: 8.8,
    quality: '4K',
    description: '殷商王朝风雨飘摇，封神大战一触即发。姜子牙携封神榜下山，一场关乎三界命运的史诗之战拉开帷幕。',
    longDescription: '《封神第二部》接续前作的宏大叙事，将封神演义中的经典桥段以现代电影工业技术重新演绎。姬发率领西岐大军东征，姜子牙手持封神榜力战群魔，元始天尊与通天教主的终极对决震撼登场。影片耗资超过十亿，打造了中国电影史上规模最大的神话战争场面。从昆仑仙境到幽冥地府，从天宫到凡间，层层递进的世界观构建让观众沉浸在一个瑰丽宏大的东方神话宇宙中。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰', '娜然'],
    genre: ['奇幻', '动作', '战争'],
    region: '中国大陆',
    duration: '156分钟',
    releaseDate: '2025-01-29',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20warrior%20in%20golden%20armor%20riding%20mythical%20beast%2C%20epic%20battle%20scene%20with%20dramatic%20lighting%2C%20dark%20mystical%20background%2C%20cinematic%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20battle%20scene%2C%20ancient%20warriors%20with%20magical%20weapons%2C%20golden%20divine%20light%2C%20dramatic%20storm%20clouds%2C%20dark%20cinematic%20atmosphere%2C%20grand%20scale%20fantasy%20war&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    title: '庆余年第三季',
    titleEn: 'Joy of Life S3',
    category: 'tv',
    year: 2026,
    rating: 9.3,
    quality: '4K',
    description: '范闲重返京都，面对更加复杂的朝堂局势。权力、阴谋、真相，一切的谜底即将揭晓，庆国风云再起。',
    longDescription: '《庆余年第三季》延续前两季的高品质制作，剧情进入最高潮。范闲在查明母亲叶轻眉死亡真相的过程中，逐渐揭开了庆国皇室最深层的秘密。陈萍萍的真实身份、庆帝的终极计划、神庙的存在之谜——所有的线索最终汇聚成一张惊天大网。本季共45集，投资规模再创新高，集结了原班人马，服化道全面升级，打戏由好莱坞动作团队指导，是年度最受期待的国产剧集。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '辛芷蕾', '宋轶', '郭麒麟'],
    genre: ['古装', '权谋', '剧情'],
    region: '中国大陆',
    duration: '45集',
    releaseDate: '2026-05-16',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20man%20in%20traditional%20black%20silk%20robes%20holding%20sword%2C%20ancient%20palace%20background%20with%20mist%2C%20dark%20moody%20lighting%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%2C%20dramatic%20lighting%20through%20silk%20curtains%2C%20dark%20and%20moody%20atmosphere%2C%20traditional%20architecture%2C%20cinematic%20lighting%2C%20mysterious%20palace%20chamber&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    featured: false,
    isNew: true,
    isHot: true,
  },
  {
    id: 5,
    title: '熊出没·重启未来',
    titleEn: 'Boonie Bears: Future Reboot',
    category: 'anime',
    year: 2026,
    rating: 8.5,
    quality: '1080P',
    description: '光头强和熊大熊二意外穿越到未来世界，面对高度发达的科技文明，他们将展开一场笑料百出的冒险之旅。',
    longDescription: '《熊出没·重启未来》是熊出没系列的第十部大电影，本次故事将舞台搬到了充满想象力的未来世界。光头强和熊大熊二在意外获得的时间机器帮助下，来到了2126年的未来世界。在这里，他们遇到了未来版的自己，也发现了一个威胁整个森林的惊天阴谋。影片在延续系列一贯的欢乐搞笑风格的同时，融入了关于环境保护和科技伦理的深刻思考，是一部适合全家人观看的优秀国产动画电影。',
    director: '林汇达',
    cast: ['张秉君', '谭笑', '张伟'],
    genre: ['动画', '喜剧', '科幻'],
    region: '中国大陆',
    duration: '99分钟',
    releaseDate: '2026-01-22',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%2C%20cute%20cartoon%20bears%20in%20futuristic%20city%2C%20bright%20colorful%20sci-fi%20scene%2C%20clean%20vibrant%20composition%2C%20animated%20film%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Futuristic%20colorful%20cartoon%20city%2C%20friendly%20animated%20style%2C%20bright%20sky%20with%20flying%20vehicles%2C%20clean%20happy%20atmosphere%2C%20family%20animation%20style%2C%20warm%20vibrant%20colors&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 6,
    title: '深海2',
    titleEn: 'Deep Sea 2',
    category: 'anime',
    year: 2026,
    rating: 8.7,
    quality: '4K',
    description: '深海世界再次开启奇幻之门，少女参宿在新的冒险中探寻内心的力量，一部令人屏息的视觉盛宴。',
    longDescription: '《深海2》延续首部作品独特的粒子水墨画风，在视觉效果上实现了新的突破。故事发生在第一部结束后的三年，长大的参宿发现自己与深海世界有着更深的联系。当深海的平衡再次被打破，她必须鼓起勇气，与新的伙伴一起踏上拯救深海世界的旅程。影片以梦幻般的视觉语言探讨了成长、勇气与自我认同的主题，每一帧画面都是一幅可以单独欣赏的艺术品。',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文'],
    genre: ['动画', '奇幻', '冒险'],
    region: '中国大陆',
    duration: '132分钟',
    releaseDate: '2026-01-25',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20young%20girl%20floating%20in%20magical%20underwater%20world%2C%20particle%20ink%20wash%20art%20style%2C%20vibrant%20blue%20and%20golden%20colors%2C%20dreamy%20surreal%20atmosphere%2C%20no%20text&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dreamy%20underwater%20fantasy%20world%2C%20swirling%20colorful%20ink%20particles%2C%20magical%20deep%20ocean%20scene%20with%20glowing%20creatures%2C%20surreal%20artistic%20style%2C%20beautiful%20blue%20and%20golden%20hues&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 7,
    title: '大江大河3',
    titleEn: 'Like a Flowing River 3',
    category: 'tv',
    year: 2026,
    rating: 9.1,
    quality: '4K',
    description: '改革开放进入深水区，宋运辉、雷东宝、杨巡三人在时代洪流中各自奋斗，书写属于他们的江河故事。',
    longDescription: '《大江大河3》是正午阳光出品的年代大剧，故事背景设定在1990年代中后期。宋运辉在国企改革中面临前所未有的挑战；雷东宝带领小雷家村走向现代化农业之路；杨巡的个体经济在市场经济浪潮中起起伏伏。三条线索交织并行，全景式展现了改革开放关键时期的中国社会变迁。王凯、杨烁、董子健的精湛演技，配合精良的制作水准，使这部剧成为年度口碑之作。',
    director: '孔笙',
    cast: ['王凯', '杨烁', '董子健', '杨采钰'],
    genre: ['剧情', '年代', '励志'],
    region: '中国大陆',
    duration: '40集',
    releaseDate: '2026-03-12',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20three%20men%20in%201990s%20Chinese%20business%20suits%2C%20industrial%20factory%20background%2C%20warm%20nostalgic%20lighting%2C%20serious%20realistic%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=1990s%20Chinese%20industrial%20cityscape%2C%20factories%20and%20cranes%20at%20sunset%2C%20warm%20golden%20light%2C%20realistic%20documentary%20style%2C%20atmospheric%20and%20nostalgic%2C%20period%20China&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 8,
    title: '王牌对王牌第九季',
    titleEn: 'Trump Card S9',
    category: 'variety',
    year: 2026,
    rating: 8.3,
    quality: '1080P',
    description: '全新一季王牌对王牌欢乐回归！沈腾、贾玲领衔王牌家族，携手飞行嘉宾带来更多爆笑游戏和温情时刻。',
    longDescription: '《王牌对王牌第九季》是浙江卫视王牌综艺节目的最新一季。本季在保留经典游戏环节的基础上，增加了更多互动性强的全新环节。王牌家族沈腾、贾玲、华晨宇、关晓彤欢乐重聚，每期邀请当红艺人组成嘉宾队展开精彩对决。节目在搞笑之余，也通过特别企划致敬经典影视作品，唤起观众的集体记忆，是一档兼具娱乐性与情怀的优质综艺节目。',
    director: '吴彤',
    cast: ['沈腾', '贾玲', '华晨宇', '关晓彤', '宋亚轩'],
    genre: ['综艺', '真人秀', '游戏'],
    region: '中国大陆',
    duration: '12期',
    releaseDate: '2026-01-10',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20colorful%20fun%20stage%20with%20celebrities%20laughing%2C%20bright%20theatrical%20lighting%2C%20happy%20entertaining%20atmosphere%2C%20TV%20studio%20setting%2C%20no%20text&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20stage%2C%20theatrical%20lighting%20and%20confetti%2C%20fun%20variety%20show%20set%2C%20warm%20entertaining%20atmosphere%2C%20professional%20studio%20production&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 9,
    title: '地球脉动第四季',
    titleEn: 'Planet Earth IV',
    category: 'documentary',
    year: 2026,
    rating: 9.8,
    quality: '4K',
    description: 'BBC史诗级自然纪录片重磅回归！以超越想象的拍摄技术，记录地球上最壮观的自然奇观和野生动物的生存故事。',
    longDescription: '《地球脉动第四季》由BBC自然历史部历时五年打造，采用最新8K摄影技术和无人机航拍，以前所未有的视角展现了地球生态系统的壮丽景观。从南极冰原到热带雨林，从深海峡谷到高山之巅，影片记录了超过200个物种的生存故事。大卫·爱登堡爵士的经典旁白配合震撼的画面，让观众在客厅就能感受大自然的魅力。这是一部每一个画面都值得截屏保存的殿堂级纪录片。',
    director: 'BBC自然历史部',
    cast: ['大卫·爱登堡'],
    genre: ['纪录片', '自然', '动物'],
    region: '英国',
    duration: '8集',
    releaseDate: '2026-04-22',
    poster: 'https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%2C%20majestic%20mountain%20gorilla%20in%20misty%20jungle%2C%20cinematic%20wildlife%20photography%2C%20dark%20green%20atmosphere%2C%20powerful%20animal%20portrait%2C%20no%20text&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20aerial%20view%20of%20pristine%20nature%20landscape%2C%20lush%20green%20rainforest%20with%20mist%2C%20dramatic%20natural%20light%2C%20cinematic%20documentary%20style%2C%20beautiful%20untouched%20wilderness&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    featured: true,
    isNew: true,
    isHot: true,
  },
  {
    id: 10,
    title: '热辣滚烫2',
    titleEn: 'YOLO 2',
    category: 'movie',
    year: 2026,
    rating: 8.1,
    quality: '1080P',
    description: '乐莹在完成自我蜕变后开启了全新人生，面对事业与情感的双重挑战，她将用拳击般的力量再次证明自己。',
    longDescription: '《热辣滚烫2》延续了第一部的励志主题，讲述了乐莹在成为健身教练后遇到的新挑战。当她的事业蒸蒸日上时，过去的阴影和新的对手同时出现。贾玲再次自导自演，以真诚的表演和幽默的叙事风格，讲述了一个关于成长、坚持和自我突破的故事。影片在笑中带泪的叙事中传递了积极向上的人生态度，是年度不可错过的温情励志喜剧。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    genre: ['喜剧', '剧情', '励志'],
    region: '中国大陆',
    duration: '129分钟',
    releaseDate: '2026-02-10',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20woman%20in%20boxing%20gloves%20with%20determined%20expression%2C%20gym%20background%20with%20warm%20lighting%2C%20inspirational%20cinematic%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20boxing%20gym%20interior%2C%20motivational%20atmosphere%2C%20golden%20hour%20light%20streaming%20through%20windows%2C%20clean%20modern%20gym%2C%20cinematic%20and%20inspiring%20mood&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 11,
    title: '哪吒之魔童闹海2',
    titleEn: 'Ne Zha 2',
    category: 'anime',
    year: 2025,
    rating: 9.5,
    quality: '4K',
    description: '哪吒与敖丙的羁绊进入全新篇章！天劫之后，哪吒肉身被毁，太乙真人以莲藕重塑其身，更大的挑战接踵而至。',
    longDescription: '《哪吒之魔童闹海2》在首部破50亿票房的辉煌基础上，以更加宏大的世界观和更加精良的制作水准震撼回归。影片讲述了哪吒重塑肉身后，与敖丙联手对抗东海龙族和天庭压迫的故事。全新的角色阵容、更加成熟的叙事手法、以及突破了动画技术极限的视觉效果，让这部续作成为国漫的又一巅峰之作。片中「我命由我不由天」的精神内核得到更深层次的诠释，热血与感动并存。',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    genre: ['动画', '奇幻', '动作'],
    region: '中国大陆',
    duration: '144分钟',
    releaseDate: '2025-07-26',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20movie%20poster%2C%20young%20warrior%20with%20fire%20wheel%20and%20red%20ribbon%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20with%20fire%20and%20water%20elements%2C%20no%20text&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%2C%20fire%20and%20water%20colliding%2C%20dramatic%20cinematic%20composition%2C%20dark%20stormy%20sky%2C%20ancient%20Chinese%20architectural%20elements&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 12,
    title: '奔跑吧第九季',
    titleEn: 'Keep Running S9',
    category: 'variety',
    year: 2026,
    rating: 8.0,
    quality: '1080P',
    description: '跑男团全新出发！李晨、郑恺、沙溢领衔新一季奔跑家族，走遍祖国大好河山，开启全新挑战模式。',
    longDescription: '《奔跑吧第九季》延续了节目一贯的欢乐竞技风格，本季以「奔跑中国」为主题，走遍全国多个特色城市。新老成员之间的化学反应更加默契，游戏环节设计更加精巧有趣。节目在保持高娱乐性的同时，也通过各站点的文化体验环节，向观众展示了中国各地的风土人情和非遗文化，是一档老少皆宜的国民综艺。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    genre: ['综艺', '真人秀', '竞技'],
    region: '中国大陆',
    duration: '12期',
    releaseDate: '2026-04-18',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20in%20colorful%20sportswear%2C%20sunny%20outdoor%20setting%2C%20energetic%20happy%20atmosphere%2C%20no%20text&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20sunny%20outdoor%20sports%20field%2C%20colorful%20obstacle%20course%2C%20blue%20sky%20with%20white%20clouds%2C%20energetic%20atmosphere%2C%20wide%20angle%20view&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 13,
    title: '舌尖上的中国5',
    titleEn: 'A Bite of China 5',
    category: 'documentary',
    year: 2026,
    rating: 9.3,
    quality: '4K',
    description: '跨越山海，寻味中国。新一季舌尖以全球化视角探寻中国味道在世界各地的传承与创新，一场美食与人文的旅程。',
    longDescription: '《舌尖上的中国5》以「世界中的中国味道」为主题，摄制组走访了全球二十多个国家和地区，记录了海外华人如何将中国美食与当地文化融合创新的动人故事。从纽约唐人街的早茶到巴黎的中法融合料理，从新加坡的海南鸡饭到墨尔本的创新川菜，影片不仅展示了美食的多样性，更深入探讨了食物如何成为文化传承的载体和身份认同的纽带。',
    director: '陈晓卿',
    cast: ['李立宏'],
    genre: ['纪录片', '美食', '人文'],
    region: '中国大陆',
    duration: '10集',
    releaseDate: '2026-06-15',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautiful%20steaming%20hot%20traditional%20Chinese%20dish%20closeup%2C%20warm%20appetizing%20lighting%2C%20dark%20wooden%20table%20background%2C%20food%20photography%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-13&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Chinese%20night%20market%20street%20food%20scene%2C%20steaming%20food%20stalls%20with%20warm%20glowing%20lanterns%2C%20busy%20atmospheric%20market%2C%20cinematic%20documentary%20style%2C%20rich%20warm%20colors&width=1600&height=700&seq=movie-banner-13&orientation=landscape',
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 14,
    title: '三体：黑暗森林',
    titleEn: 'The Dark Forest',
    category: 'tv',
    year: 2026,
    rating: 9.4,
    quality: '4K',
    description: '面壁计划启动！四位面壁者承担起拯救人类文明的使命，而破壁人的出现让一切陷入危机。宇宙的黑暗森林法则即将揭晓。',
    longDescription: '《三体：黑暗森林》根据刘慈欣同名科幻巨著改编，是《三体》系列的第二部。本季聚焦「面壁计划」的核心叙事，罗辑、希恩斯、雷迪亚兹、泰勒四位面壁者以各自的方式试图对抗三体文明的入侵。剧集完美还原了原著中宏大的宇宙观和精妙的科幻设定，特效制作达到国际一线水准，是国产科幻剧集的现象级作品。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健', '李小冉'],
    genre: ['科幻', '剧情', '悬疑'],
    region: '中国大陆',
    duration: '30集',
    releaseDate: '2026-09-01',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20mysterious%20man%20in%20dark%20suit%20facing%20cosmic%20universe%2C%20dark%20space%20background%20with%20stars%2C%20philosophical%20minimalist%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-14&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Deep%20space%20with%20galaxy%20and%20nebula%2C%20mysterious%20dark%20cosmic%20scene%2C%20minimalist%20sci-fi%20aesthetic%2C%20stars%20and%20cosmic%20dust%2C%20atmospheric%20and%20profound&width=1600&height=700&seq=movie-banner-14&orientation=landscape',
    featured: false,
    isNew: true,
    isHot: true,
  },
  {
    id: 15,
    title: '志愿军：存亡之战',
    titleEn: 'The Volunteers: Battle of Life',
    category: 'movie',
    year: 2026,
    rating: 8.9,
    quality: '4K',
    description: '抗美援朝战争中最惨烈的战役之一。中国人民志愿军在极端严寒与装备悬殊的情况下，以血肉之躯捍卫阵地。',
    longDescription: '《志愿军：存亡之战》聚焦抗美援朝战争中的长津湖战役，以极具震撼力的战争场面和细腻的人物刻画，展现了志愿军战士在零下四十度的极寒环境中浴血奋战的英雄故事。陈凯歌导演以宏大的战争史诗视角，还原了那段波澜壮阔的历史。影片的战斗场面由《1917》的特效团队参与制作，在视觉呈现上达到国产战争片的新高度。',
    director: '陈凯歌',
    cast: ['朱一龙', '张子枫', '辛柏青', '吴京', '段奕宏'],
    genre: ['战争', '历史', '剧情'],
    region: '中国大陆',
    duration: '162分钟',
    releaseDate: '2026-10-01',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%2C%20soldiers%20in%20winter%20battlefield%20with%20determined%20expressions%2C%20snowy%20mountain%20background%2C%20dramatic%20cinematic%20lighting%2C%20epic%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-15&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20winter%20war%20battlefield%2C%20soldiers%20marching%20through%20deep%20snow%20in%20mountains%2C%20dramatic%20cold%20atmosphere%2C%20historical%20cinematic%20style%2C%20grand%20scale%20composition&width=1600&height=700&seq=movie-banner-15&orientation=landscape',
    featured: false,
    isNew: true,
    isHot: true,
  },
];

export const getFeaturedMovies = () => movies.filter((m) => m.featured);
export const getNewMovies = () => movies.filter((m) => m.isNew);
export const getHotMovies = () => movies.filter((m) => m.isHot);
export const getMoviesByCategory = (category: string) => {
  if (category === 'all') return movies;
  return movies.filter((m) => m.category === category);
};
export const getMovieById = (id: number) => movies.find((m) => m.id === id);